<div [copoScroller]="{restoreAfterViewInit: false}" #scroller="copoScroller" class="sidenav-content" @routeAnimation>

	<ng-template #loading>
		<copo-loading-spinner *ngIf="!isError"></copo-loading-spinner>
	</ng-template>

	<ng-container *ngIf="isEmpty">
		<div class="card-block-data">
			<div class="nodata-label">
				<b translate> product.not.exist </b>
			</div>
		</div>
	</ng-container>

	<div *ngIf="isError" class="card-product-block">
		<div class="card-block copo-notification-block">
			<mat-icon svgIcon="alert" [attr.title]="'quapp.alert' | translate" class="copo-notification-icon copo-hint-warning"></mat-icon>
			<div>
				<div class="card-header-label"> <b translate> quapp.error </b></div>
				<div translate>product.error</div>
			</div>
		</div>
	</div>

	<ng-container *ngIf="!isLoading && !isError && !isEmpty && productFieldsObs else loading">
		<!-- title -->
		<div class="card-title-block">
			<copo-back-button></copo-back-button>
			<div *ngIf="userPartReference" class="card-title-label">{{userPartReference}}</div>
			<div class="card-title-label">{{subcategory}}&nbsp;&&nbsp;{{form}}</div>
		</div>

		<!-- content -->
		<copo-product-card-content [productFieldsObs]="productFieldsObs"></copo-product-card-content>
	</ng-container>
</div>
